import { Box, Container } from '@medely/web-components';
import React, { ReactElement, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import TopBar from 'containers/TopBar';
import Unimpersonate from 'components/Unimpersonate';
import useCurrentUser from 'hooks/useCurrentUser';
import { useConfigurationContext } from '@medely/ui-kit';
import useSnackbar from 'hooks/useSnackbar';
import ProfessionalTermsOfServiceModal from 'components/TermsOfService/ProfessionalTermsOfServiceModal';
import ProViewContent from 'components/ProViewContent';
import { NumberParam, useQueryParam } from 'use-query-params';
import { PromptForNewCondition } from './components/credentials/conditionDialogs/PromptForNewCondition';
import { AssignmentProvider, isSaasAccount, isAgencyAccount } from '@mp';
interface IProViewProps {
  children?: ReactNode | ReactNode[];
}

const ProView = ({ children }: IProViewProps): ReactElement => {
  const { isApplicant, currentUser } = useCurrentUser();
  const snackbar = useSnackbar();
  const config = useConfigurationContext();
  const location = useLocation();
  const isNonSaasOrAgencyApplicant =
    isApplicant && !(isSaasAccount(currentUser) || isAgencyAccount(currentUser));

  const [newConditionId] = useQueryParam('newConditionId', NumberParam);

  // Don't redirect if already on /application or MFA routes to avoid infinite loop
  const isOnApplicationRoute = location.pathname.startsWith(`${config.root}/application`);
  const isOnMfaRoute = location.pathname.startsWith(`${config.root}/mfa-`);
  if (isNonSaasOrAgencyApplicant && !isOnApplicationRoute && !isOnMfaRoute) {
    return <Navigate to={`${config.root}/application`} replace />;
  }

  return (
    <AssignmentProvider>
      <Box sx={{ overflow: 'auto', height: '100vh' }} id="pro-view-root">
        <Unimpersonate />
        <TopBar />
        <ProfessionalTermsOfServiceModal
          onError={(message) => {
            snackbar.error(null, message);
          }}
          onSuccess={() => {
            snackbar.success('Success');
          }}
        />
        <Container maxWidth="sm">
          <ProViewContent>{children}</ProViewContent>
        </Container>
      </Box>
      {Boolean(newConditionId) && newConditionId && (
        <PromptForNewCondition conditionId={newConditionId} />
      )}
    </AssignmentProvider>
  );
};

export default ProView;
